import React, { useState } from 'react';
import { Alert, Button, Form, Modal, Spinner } from 'react-bootstrap';
import companyCityService from '../../services/companyCityService';
import { mapCityToOption } from '../../utils/cityHelpers';
import './AffiliationBadge.css';

export default function CreateCompanyCityModal({ show, onHide, onCreated }) {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleClose = () => {
    if (saving) return;
    setName('');
    setError('');
    onHide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const trimmed = name.trim();
    if (!trimmed || trimmed.length < 2) {
      setError('Le nom de la ville doit contenir au moins 2 caractères.');
      return;
    }

    try {
      setSaving(true);
      const res = await companyCityService.create({ name: trimmed, is_active: true });
      const created = res?.data;
      if (!res?.success || !created?.id) {
        throw new Error(res?.message || 'Création impossible');
      }
      const option = mapCityToOption(created);
      setName('');
      setError('');
      onHide();
      onCreated?.(option);
    } catch (err) {
      setError(err.message || 'Erreur lors de la création de la ville');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdropClassName="co-aff-create-backdrop"
      className="co-aff-create-modal"
      aria-labelledby="co-city-create-title"
    >
      <Modal.Header closeButton className="co-aff-create-modal__header">
        <Modal.Title id="co-city-create-title">Nouvelle ville</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error ? <Alert variant="danger">{error}</Alert> : null}
          <Form.Group>
            <Form.Label>Nom de la ville</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Ex. Ambatolampy"
              maxLength={100}
              autoFocus
              disabled={saving}
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleClose} disabled={saving}>
            Annuler
          </Button>
          <Button variant="primary" type="submit" disabled={saving}>
            {saving ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Enregistrement…
              </>
            ) : (
              'Ajouter la ville'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
